import type {
  AuditLogEntry,
  AuditLogFilterOptions,
  AuditLogFilters,
} from "@/types/audit";
import type { PaginatedResponse } from "@/types/rbac";
import { apiClient } from "./client";

export const auditApi = {
  getLogs(filters: AuditLogFilters): Promise<PaginatedResponse<AuditLogEntry>> {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== "") {
        params.set(key, String(value));
      }
    }
    return apiClient.get<PaginatedResponse<AuditLogEntry>>(
      `/admin/audit-logs?${params.toString()}`,
    );
  },

  getFilterOptions(): Promise<AuditLogFilterOptions> {
    return apiClient.get<AuditLogFilterOptions>("/admin/audit-logs/filters");
  },
};
